export default function KPIs() {
  const kpis = [
    {
      icon: 'ri-group-line',
      label: 'عدد المستفيدين من المساحة',
      value: '10,000',
      period: 'سنويًا',
      color: 'from-[#FF6B6B] to-[#FF8E53]',
      percentage: 85
    },
    {
      icon: 'ri-lightbulb-line',
      label: 'عدد المشاريع الناتجة عن مساحات التطوير والتفكير',
      value: '50',
      period: 'مشروع سنويًا',
      color: 'from-[#FF8E53] to-[#FFA07A]',
      percentage: 60
    },
    {
      icon: 'ri-line-chart-line',
      label: 'نسبة الاستدامة',
      value: '10%',
      period: 'من المشاريع',
      color: 'from-[#FFA07A] to-[#FFB88C]',
      percentage: 10
    },
    {
      icon: 'ri-star-line',
      label: 'رضا الشركاء',
      value: '80%',
      period: 'معدل الرضا',
      color: 'from-[#FF6B6B] to-[#FF8E53]',
      percentage: 80
    },
    {
      icon: 'ri-briefcase-line',
      label: 'عدد الشركاء',
      value: '10',
      period: 'شريك استراتيجي',
      color: 'from-[#FF8E53] to-[#FFA07A]',
      percentage: 70
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            مؤشرات الأداء الرئيسية
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            معايير قياس النجاح والأثر المستدام
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {kpis.map((kpi, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-white to-gray-50 p-8 rounded-3xl border-2 border-gray-200 hover:border-[#FF6B6B] hover:shadow-2xl transition-all duration-500 overflow-hidden"
            >
              {/* Background Pattern */}
              <div className="absolute inset-0 opacity-5">
                <div className={`w-full h-full bg-gradient-to-br ${kpi.color}`}></div>
              </div>

              {/* Content */}
              <div className="relative z-10">
                {/* Icon */}
                <div className={`w-16 h-16 bg-gradient-to-br ${kpi.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500`}>
                  <i className={`${kpi.icon} text-white text-3xl`}></i>
                </div>

                {/* Label */}
                <h4 className="font-bold text-lg text-gray-900 mb-4">
                  {kpi.label}
                </h4>

                {/* Value with animation */}
                <p className="text-5xl font-extrabold mb-2 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] bg-clip-text text-transparent group-hover:scale-110 transition-transform duration-300">
                  {kpi.value}
                </p>

                {/* Period */}
                <p className="text-gray-600 text-sm mb-4">
                  {kpi.period}
                </p>

                {/* Progress Bar */}
                <div className="relative w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div 
                    className={`h-full bg-gradient-to-r ${kpi.color} rounded-full transition-all duration-1000 ease-out group-hover:w-full`}
                    style={{ width: `${kpi.percentage}%` }}
                  ></div>
                </div>

                {/* Trend Indicator */}
                <div className="mt-4 flex items-center gap-2">
                  <i className="ri-arrow-up-line text-green-500 text-lg"></i>
                  <span className="text-sm text-green-600 font-semibold">
                    نمو متوقع
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-br from-gray-900 to-gray-800 text-white px-10 py-6 rounded-2xl shadow-xl">
            <p className="text-lg">
              <i className="ri-information-line text-2xl ml-3"></i>
              يتم قياس جميع المؤشرات بشكل دوري وتقديم تقارير شفافة للشركات الراعية
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
